import React, { useState } from 'react';

import { Dialog, IconButton, Fab } from '@mui/material';

import { CloseIcon } from 'src/app/components/icons/close';

import { DebugIcon } from './debug-icon';
import { ResourceContextDebugViewer } from './resource-context-debug-viewer';

/**
 * FloatingDebugButton - A floating action button that opens the context debug viewer.
 * Always visible for development/testing purposes.
 */
export function FloatingDebugButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Fab
        aria-label='Open resource context debug viewer'
        color='primary'
        sx={{
          position: 'fixed',
          bottom: 80,
          left: 15,
          zIndex: 1000,
          width: 35,
          height: 30,
        }}
        onClick={() => setIsOpen(true)}
      >
        <DebugIcon />
      </Fab>

      <Dialog
        fullWidth
        maxWidth='xl'
        open={isOpen}
        PaperProps={{
          style: {
            height: '90vh',
            maxHeight: '900px',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
        onClose={() => setIsOpen(false)}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 600 }}>
            Dutchie Intelligence - Resource context debugger
          </h2>
          <IconButton size='small' onClick={() => setIsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <div
          style={{
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <ResourceContextDebugViewer />
        </div>
      </Dialog>
    </>
  );
}
